import userService from '../../services/userService'

const state = {
    user: [],
}


const getters = {
    user: state => {
        return state.user
    },

}

const actions = {
    changePassUser({commit},params){
        return new Promise((resolve, reject)=>{
            userService.ChangePass(params).then( (response)=> {
            resolve(response)}, 
            ).catch((error) => { //
                // return Promise.reject(error)
                console.log( "error" +JSON.stringify(error.response))//
                reject(error)//
          })//

        // userService.ChangePass(params).then( (response)=> {
        //         // commit('addBasews', response)
        //         console.log(response)
        //         resolve(response)}, 
        //         (error) => { //
        //             // return Promise.reject(error)
        //             console.log( "error" +JSON.stringify(error.status))//
        //             reject(error)//
        //       })//




        })
    },
    getUser({commit}){
        userService.fetchUser()
        .then(user => {
            commit('setUser', user)
        })
    },
    getUser2({commit}, params){
        userService.fetchUser2(params)
        .then(user => {
            commit('setUser', user)
        })
    },
    editUser({commit}, user){
        userService.editUser(user[0],user[1])
        .then(response => {
             //onsole.log(JSON.stringify(response))
            commit('editUser', response)
        })
    },
    populateUsers({commit}, user){
        userService.populateNewUsers(user)
        .then(response => {               
            commit('postPopulate', response)
        }) 
    }
    
    
    

    }

    const mutations = {
        
        setUser(state, user){
            state.user = user
        },
        editUser(state, response){
            console.log(JSON.stringify( state.user))
            let record = state.user.findIndex(
                // (element)=> {
                // return  (Number(element.id) == Number(response.id))}
                function (element) { 
                    console.log(element.id)
                    return element.id == response.id; 
                }
                )
            
            console.log((record))
            state.user[record] = response
            //console.log(JSON.stringify( state.user[record]))
           // state.user = user["user"]
        },
        postPopulate(state, response){
            state.user.push(response)
        }
    }
    
    export default {
        namespaced:true,
        state,
        getters,
        actions,
        mutations
    }